import React from 'react'
import classNames from 'classnames'

import Typography from '~/components/elements/Typography/Typography'

import styles from './LabelValue.module.scss'

type TypographyComponent = (typeof Typography)[keyof typeof Typography]

export type LabelValueLayout = 'horizontal' | 'vertical'

interface LabelValueProps {
  LabelComponent?: TypographyComponent | null
  LabelProps?: Record<string, unknown>
  ValueComponent?: TypographyComponent | null
  ValueProps?: Record<string, unknown>
  className?: string
  label: React.ReactNode
  layout?: LabelValueLayout
  value: React.ReactNode
}

export const LabelValue = ({
  label,
  value,
  LabelComponent = Typography.H3,
  ValueComponent = Typography.ParagraphSm,
  LabelProps = {},
  ValueProps = {},
  className,
  layout = 'horizontal',
}: LabelValueProps) => {
  const containerClassName = classNames(
    layout === 'vertical'
      ? styles.containerVertical
      : styles.containerHorizontal,
    className,
  )

  return (
    <dl className={containerClassName}>
      <dt>
        {LabelComponent ? (
          <LabelComponent {...LabelProps}>{label}</LabelComponent>
        ) : (
          label
        )}
      </dt>
      <dd>
        {ValueComponent ? (
          <ValueComponent {...ValueProps}>{value}</ValueComponent>
        ) : (
          value
        )}
      </dd>
    </dl>
  )
}
